import { Component, OnDestroy, OnInit,  ViewContainerRef, ViewChild} from '@angular/core';
import {DemoService} from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';


import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable} from 'rxjs';



import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import {SubjectServiceComponent} from './../../../admin/jobs/subjects/subject-service/subject-service.component';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { DataUtil } from '@syncfusion/ej2-data';


@Component({
  selector: 'app-client-job-subject',
  templateUrl: './client-job-subject.component.html',
  styleUrls: ['./client-job-subject.component.css']
})
export class ClientJobSubjectComponent implements OnInit, OnDestroy {
  subjects: any;
  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  subject_notes: any;
  subject_id: number;
  job_status_run: any;
  subject_progress: any;
  job_types: any;
  job_type: any;
  job_type_location: any;
  job_type_court: any;
  job_type_document: any;
  job_type_affidavit: any;
  job_id: any;
  file_number: any;
  subject_service: any;
  subject_services: any;

  bsModalRef: BsModalRef;
  loadComponent: boolean;
  initialPage: any;
  @ViewChild('grid')
  public grid: GridComponent;
  subject_number: any;
  block_client_access = 0;
  job: any;
  subject_contact_numbers: any;
  subject_contact_emails: any;
  job_subjects: any;
  job_subjects_count: any;
  client_additional_create_data_HTML: any;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router, 
     public HttpClient: HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
    ) {





      this.nav = document.querySelector('nav.navbar');
      

    // login vars
    this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
    console.log('sessionUserId: ', this.currentUserVAR.user_id );
    console.log('sessionUsername: ', this.currentUserVAR.username );
    // Set loggind in User Value (USER ID)
    this.sessionUserId = this.currentUserVAR.user_id;
    this.sessionUserId = this.currentUserVAR.username;
    this.sessionBrandId = this.currentUserVAR.brand_id;


      }

  ngOnInit() {
    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
    this.getJobSubject(this.subject_id);
    this.getJobStatusNames();
    this.getSubjectServiceAll(this.subject_id); // serives list new
    this.getSubjectContactNumbers(this.subject_id);
    this.getSubjectContactEmails(this.subject_id);

  }


ngOnDestroy(){
 // this.subjects.unsubscribe();

}


// no longer being used as would not pass the variables to the ts file.
openModalWithComponent() {
  /* this is how we open a Modal Component from another component */
  console.log('open model');

  const initialState = {
    subject_id: this.subject_id,
    passed_job_id: 'A Fat Cat',
    title: 'Modal Window Title'
  };
  this.bsModalRef = this.modalService.show(SubjectServiceComponent, {initialState});
 this.bsModalRef.content.passed_job_id = 'Close';
  this.bsModalRef.content.job_id = this.job_id;
  this.bsModalRef.content.subject_id = this.subject_id;
};



loadMyChildComponent() {
  this.loadComponent = true;
}

closeMyChildComponent() {
  this.loadComponent = false;
}




  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subjects = data;
        const res = data[0];
    
    
this.getJob(res.job_id); // get to set the client secuitry vars
    this.job_id = res.job_id;
    
    
        this.getSubjectNotes(res.subject_id);
        // load subject history
        this.getSubjectProgress(res.job_id, res.file_number);

// get job type in relation to subject
this.getJobType(res.job_type_id);
this.getJobTypeLocation(res.job_type_location_id);
this.getJobTypeCourt(res.job_type_court_id);
this.getJobTypeDocument(res.job_type_document_type_id);
this.getJobTypeAffidavit(res.job_type_affidavit_type_id);

this.job_id = res.job_id;
this.file_number = res.file_number;
this.subject_number = res.subject_number;

// count existing subjects validate for edit or not.
this.getJobsTableDataSubjects(this.job_id);


//this.getSubjectNotesProgressionTable(res.job_id, res.file_number );




      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  // update was here for onit but moved for onchange
  updateJobSubject(model) {

    // first make a copy of subject and place in to subject_history table. // done on insert in PHP

model.updated_by = this.sessionUserId;
    this._demoService.updateJobSubject(model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Subject Updated');
       this.getJobSubject(model.subject_id);
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false);
      this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']);
                 return true;
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error saving Job!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')


  );
  }


  getSubjectNotes(subject_id) {
    this._demoService.getSubjectNotes(subject_id).subscribe(
      data => { this.subject_notes = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }



    private getJobStatusNames() {
      this._demoService.getJobStatusNames()
        .subscribe(
          res => this.job_status_run = res,
          err => console.error(err.status)
        );
    }


    getJob(job_id) {
      this._demoService.getJobID(job_id).subscribe(
         data => { this.job = data;
          let res = data[0];
          // Run the job data queries.

          console.log('Current Brand Reprot ID: ', res.brand_report_id);
          console.log('Current Brand ID: ', this.gfunc.sessionBrandId);
          
          const report_brand_id = res.brand_report_id;
          // blick access for client
          if (report_brand_id != this.gfunc.sessionBrandId) {
           this.block_client_access = 1; // true
          }
          
          console.log('block_client_access: ', this.block_client_access);

          this.client_additional_create_data_HTML =  res.client_additional_create_data_HTML

          // 2025 August
          // new subject count checker so that  Draft subjects with more than one cannot be opened by client


        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }


// this reports as failes but actually works.

    newSubjectReference(model){
      this._demoService.newSubjectReference(model).subscribe(
        data => { // this.new_subject_data = data; // this is the retuned json upon creation.
        this.toastr.success('New Subject Reference Data Entered');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

         // Setup annd the Currents before we redirec the page
         // Needs to be a Function to update the ObserveOnOperator.
         // this.newCTrace_id(this.latest_trace_id);
         // or this.cdata.changeCTrace_id("999");

       // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

        this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

           return true;


        },
        error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
       //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
       // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
       this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
       this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));

         // console.log(error(error));
         //return console.log(error);
        }
    );


    };


    subjectView2(subject_id) {

      this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']));

    // works but does not refresh the page only if set up as a listner.
    // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
   }

   subjectView2Client(subject_id) {

    // :: OLD WAY
    // this.router.navigateByUrl('client/jobs', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/client/jobs/subject/' + subject_id + '']));

    // :: New Way
    this.router.navigate(['/client/jobs/j' + subject_id + ''], { skipLocationChange: true })
    .then(() => this.router.navigate(['/client/jobs/subject/' + subject_id + ''])
    );

  // works but does not refresh the page only if set up as a listner.
  // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
 }

   jobView(job_id) {
    this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  }

  jobViewClient(job_id) {
    this.router.navigate(['/client/jobs/view-job/' + job_id + '']);
  }

  subjectCommunication(subject_id) {
    this.router.navigate(['/admin/jobs/subject/communication/' + subject_id + '']);
  }

  subjectDocuments(subject_id) {
    this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
  }




   getSubjectProgress(job_id, file_number){
    this._demoService.getSubjectProgress(job_id, file_number).subscribe(
      data => { this.subject_progress = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }


// get job type details.
getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => {
      this.job_type = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeLocation(job_type_location_id) {
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
     data => { this.job_type_location = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeCourt(job_type_court_id) {
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
     data => { this.job_type_court = data;
     // let res = data[0];
     // this.model.job_type_id = res.job_type_id;
     // this.getJobTypeLocations(res.job_type_id);


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypeDocument(job_type_document_type_id) {
  this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
     data => { this.job_type_document = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypeAffidavit(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
     data => { this.job_type_affidavit = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





 getSubjectNotesProgressionTable(job_id, file_number, model) {
  this._demoService.getSubjectNotesProgressionTable(job_id, file_number, model).subscribe(
    data => { this.subject_notes = data;
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  ); }








  getSubjectServiceAll(subject_id) {
    this._demoService.getSubjectServiceAll(subject_id).subscribe(
      data => { this.subject_service = data;
       // console.log("Done loadng USER");
       // console.log(this.users);
      let res = data[0];

      /*
       this.getServiceMethod(res.subject_service_method_id);
       this.getSubjectRelationship(res.fellow_occupants_relationship);
       this.getExactServiceMethod(res.exact_service_method);
       this.getSubjectServiceOutcome(res.subject_service_outcome_id);
       this.getBrandById(res.who_service); // get agent/brand that served
        this.getSubjectLocationStatus(res.subject_location_status_id);
        this.getSubjectLocationStatusFound(res.subject_location_status_found_id);
       */
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }



    getSubjectServices(subject_id) {
      this._demoService.getSubjectServices(subject_id).subscribe(
        data => { this.subject_services = data;
         // console.log("Done loadng USER");
         // console.log(this.users);
         let res = data[0];

         // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
         // this.getUsersById(res.who_attended);
        },
        error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
        }
      ); }



      deleteSubjectService(subject_service_id) {
        if (confirm('Are you sure you want to delete this Service Information? ')) {
          this._demoService.deleteSubjectService(subject_service_id).subscribe(
             data => {
              this.getSubjectServices(this.subject_id);
               return true;
             },
             error => {
               console.error('Error deleting Attendence!');
              return console.log(error);
             }
          );
      }
      }


      refreshGrid(){ // refresh the databutton
        // this.getFiles();
        // this.getJobFilesGrid(this.model);

       // this.getSubjectNotes(this.subject_id)
         this.grid.refresh();
       };
       

       getSubjectContactNumbers(subject_id) {
        this._demoService.getSubjectContactNumbers(subject_id).subscribe(
           data => { this.subject_contact_numbers = data; },
           err => console.log(err),
            () => {
              // console.log('done loading SCN');
                          }
              );
       }



       getSubjectContactEmails(subject_id) {
        this._demoService.getSubjectContactEmails(subject_id).subscribe(
           data => { this.subject_contact_emails = data; },
           err => console.log(err),
            () => {
              // console.log('done loading SR');
                          }
              );
       }
      

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.bsModalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
this.subjectView2(this.subject_id);
};




  getJobsTableDataSubjects(job_id) {
    this._demoService.getJobsTableDataSubjects(job_id).subscribe(
      data => {
        this.job_subjects = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.job_subjects = DataUtil.parse.parseJson(data);

        this.job_subjects_count = this.job_subjects.length;
//         this.job_subjects_not_closed_count = this.subjects_urgent.filter((item) => item.job_status !== 'CLOSED')
//         .map((item) => +item.invoice_id).length;


//         // using loadsash to group
//    this.job_subjects_grouped = _.groupBy(
//   this.subjects_urgent.filter(item => item.job_status !== 'CLOSED'),
//   'file_number'
// );

        // console.log("Done loadng USER");
        // console.log(this.users);


      },
      error => {
        //  console.error('Error Loading User!');
        // return Observable.throw(error);
      }
    );
  }




}



